
	<style>
    .gcat-item{
       float: left;
      height: 364px;
      position: relative;
      width: 298px;
      padding-left : 2px;
      padding-bottom: 2px;
      overflow: hidden;
    }
    .gcat-item img{
      width: 100%;
      height: 100%;
    }
    .gcat-item-title{
      background: none repeat scroll 0 0 rgba(0, 0, 0, 0.7);
      color: #fff;
      font-size: 18px;
      height: 183px;
      line-height: 20px;
      padding-top: 150px;
      position: absolute;
      text-align: center;
      top: 0;
      width: 298px;
      display: none;
    }
    .gcat-item a.gcat-item-title:hover{
      color: #fff;
      text-decoration: none;
    }
    .gcat-item:hover a.gcat-item-title{
      display: block;
      color:#fff;
    }

    .menu-item{
       float: left;
      height: 212px;
      position: relative;
      width: 139px;
      padding-left : 2px;
      padding-bottom: 2px;
      overflow: hidden;
    }
    .menu-item img{
      width: 100%;
      height: 100%;
    }
    .menu-item-title{
      background: none repeat scroll 0 0 rgba(0, 0, 0, 0.7);
      color: #fff;
      font-size: 18px;
      height: 212px;
      line-height: 20px;
      padding-top: 50px;
      position: absolute;
      text-align: center;
      top: 0;
      width: 139px;
      display: none;
    }
    .menu-item a.menu-item-title:hover{
      color: #fff;
      text-decoration: none;
    }
    .menu-item:hover a.menu-item-title{
      display: block;
      color:#fff;
    }
  </style>
      
      
      <div style="position: absolute;
        right: 580px;
        /* right: 278px; */
        top: 0px;  ">
        <div class="offcanvas">
          <ul id="menu-vietnamese-menu" class="main-nav">
            <li>
              <div class="menu-item" style="height: 141px;width: 150px;">
                <a href="/" itemprop="name">
                  <!-- <img [src]="" title="TRANG CHỦ" itemprop="image">   -->
                  TRANG CHỦ            
                </a>
                <a class="menu-item-title" href="/" style="height: 141px;">TRANG CHỦ</a>
              </div>
              <div class="menu-item" style="height: 141px;width: 150px;">
                <a href="/" itemprop="name">
                  <!-- <img [src]="" title="DỰ ÁN" itemprop="image">    -->
                  DỰ ÁN           
                </a>
                <a class="menu-item-title" href="/products" style="height: 141px;">DỰ ÁN</a>
              </div>
              <div class="menu-item" style="height: 141px;width: 150px;">
                <a href="/" itemprop="name">
                  <!-- <img [src]="" title="TRANG CHỦ" itemprop="image">   -->
                  CHÚNG TÔI
                </a>
                <a class="menu-item-title" href="/introduce" style="height: 141px;">CHÚNG TÔI</a>
              </div>
              <div class="menu-item" style="height: 141px;width: 150px;">
                <a href="/" itemprop="name">
                  <!-- <img [src]="" title="DỰ ÁN" itemprop="image">               -->
                  LIÊN HỆ
                </a>
                <a class="menu-item-title" href="/contact" style="height: 141px;">LIÊN HỆ</a>
              </div>
              
            </li>
          </ul>
        </div>
        <button class="offcanvas-toggle">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      
      
      <div class="logo">
        <a href="/"><img src="/assets/Home_files/logo.png" title="Trang chủ"></a>
        <div class="moduletable_lienhe">
            <div class="custom_lienhe">
                <p><img src="/assets/Home_files/lienhe_diachicty.jpg" alt="dia chi lien he" width="300" height="200"></p>
            </div>
        </div>
    
      </div>
      
      <div class="main-component">
        <div id="system-message-container">
        </div>
        <div class="lien-he">
            <div class="fb"><a href="https://www.facebook.com/nowa.vn" rel="alternate"><img src="/assets/Home_files/fb.png" alt="" width="75"></a></div>
            <div class="anhlh"><img src="/assets/Home_files/vanphong.jpg" alt="anh van phong" width="300" height="300"></div>
            <div class="thongtin">&nbsp;</div>
        </div> 				 
    </div>
    <div class="body-gioithieu">
        
    </div>
      
      <script type="text/javascript">
        (function ($) {
          'use strict';
    
    
    
          // Full-screen navigation
          var $offcanvasToggle = $('.offcanvas-toggle');
          var $offcanvas = $('.offcanvas');
          $offcanvasToggle.on('click', function () {
            $offcanvas.toggleClass('offcanvas--active');
            $offcanvasToggle.toggleClass('offcanvas-toggle--active');
          });
    
        }(jQuery));
      </script>
      
    
    